import { render, staticRenderFns } from "./DropdownContainer.vue?vue&type=template&id=156ee987&scoped=true"
import script from "./DropdownContainer.vue?vue&type=script&lang=js"
export * from "./DropdownContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ee987",
  null
  
)

export default component.exports